








import Vue from "vue";
import CampaignTable from "@/components/campaigns/CampaignTable.vue";

export default Vue.extend({
  name: "CampaignList",
  components: { CampaignTable },
});
